export const chatData = [
    {
        mobile: "1234567890",
        userInfo: [
            //create sample data having id, name, status, userImg, about, email, chatmessage as list
            {id: 1, name: "Alice", status: "Online", userImg: "https://picsum.photos/536/354", about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.", email: "abc@abc.com", chatMessage: [{
                message: "Hello, how are you?",
                timestamp: "2023-10-01 10:00 AM",
                type: "received"
            },
            {
                message: "I am good, thanks, How about you?",
                timestamp: "2023-10-01 10:0 5AM",
                type: "sent"
            }
        ]}, 
            {id: 2, name: "Bob", status: "Offline", userImg: "https://picsum.photos/536/354", about: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.", email: "abc1@abc.com", chatMessage: [{
                message: "Hey, are you there?",
                timestamp: "2023-10-01 10:10 AM",
                type: "received"
            },
            {
                message: "Yes, I am here.",
                timestamp: "2023-10-01 10:15 AM",
                type: "sent"
            }
        ]},
            {id: 3, name: "Charlie", status: "Busy", userImg: "https://picsum.photos/536/354", about: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.", email: "abc2@abc.com", chatMessage: [{
                message: "Can we reschedule our meeting?",
                timestamp: "2023-10-01 10:20 AM",
                type: "received"
            },
            {
                message: "Sure, let me know your availability.",
                timestamp: "2023-10-01 10:25 AM",
                type: "sent"
            }
        ]}
        ]
    }
]